import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { Amplify } from 'aws-amplify'
import awsconfig from '../../../aws-exports'
import { routePaths } from '../../../constants/routes'
import { sessionStorageKeyConstants } from '../../../constants/session-storage-key-constants'

Amplify.configure(awsconfig)

function PrivateRoutes() {
  const isAuthenticated = sessionStorage.getItem(sessionStorageKeyConstants.ACCESS_TOKEN)
  return isAuthenticated ? <Outlet /> : <Navigate to={routePaths.LOGIN} replace />
}

export default PrivateRoutes
